import { gql } from '@apollo/client';

export const COMPUTE_ABSOLUTE_TIME_PERIOD = gql`
  query ComputeAbsoluteTimePeriod($input: RelativeTimePeriodComputeInput!) {
    absoluteTimePeriodCompute(input: $input) {
      start
      end
    }
  }
`;
